import { render, staticRenderFns } from "./pay-pwd.vue?vue&type=template&id=08e7bbe9&scoped=true&"
import script from "./pay-pwd.vue?vue&type=script&lang=js&"
export * from "./pay-pwd.vue?vue&type=script&lang=js&"
import style0 from "./pay-pwd.vue?vue&type=style&index=0&id=08e7bbe9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7bbe9",
  null
  
)

export default component.exports